module.exports = __webpack_public_path__ + "components/country-flag/static/sa-3e61b943d4fbde58f51851af5838fb3c.svg";